import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useActionsTableColumns } from './useActionsTableColumns';

import {
  atomDetailCampaign,
  atomInfoCampaignV1,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import { useCampaignActionsMutationContext } from '@/modules/CampaignsModule/contexts/CampaignActionsContext';
import { ITableCampaignActions } from '@/modules/CampaignsModule/interfaces/CampaignActions';

export const useHandleEvents = () => {
  const navigate = useNavigate();

  const { setClearFilterBy } = useCampaignActionsMutationContext();
  const { channelInfoByID } = useActionsTableColumns();
  const detailCampaign = useAtomValue(atomDetailCampaign);
  const setInfoCampaignV1 = useSetAtom(atomInfoCampaignV1);

  const handleCreateActionByCampaign = useCallback(() => {
    console.log('🚀 ~ handleCreateActionByCampaign');
  }, []);

  const handleRowClick = useCallback(
    (row: ITableCampaignActions) => {
      const { name, channel } = row.action;
      const route = channelInfoByID[channel as keyof typeof channelInfoByID].route;
      setInfoCampaignV1({
        campaign: {
          id: Number(detailCampaign?.campaignId),
          name: detailCampaign?.name ?? '',
        },
        action: {
          id: row.action.actionId,
          name: name,
        },
      });
      navigate(`${route}/${row.action.actionId}`);
    },
    [channelInfoByID, detailCampaign, navigate, setInfoCampaignV1]
  );

  const handleClickEmptyScreenNoResult = useCallback(() => {
    setClearFilterBy(true);
  }, [setClearFilterBy]);

  return {
    handleCreateActionByCampaign,
    handleClickEmptyScreenNoResult,
    handleRowClick,
  };
};
